import { useSelector } from 'react-redux'

import { Tooltip } from '@/components/primitives/Tooltip'
import { selectCompaniesAsArray } from '@/features/domain/company'

import { form } from '../../formState'
import { useTexts } from '../../hooks/useTexts'

export function CompaniesAccess() {
  const allCompaniesCount = useSelector(selectCompaniesAsArray).length
  const disabled = allCompaniesCount === 0

  const texts = useTexts()

  if (disabled) {
    return (
      <Tooltip placement="bottom" title={texts.tooltip.isCompanyFiltered.disabled}>
        <form.Checkbox
          label={texts.labels.isCompanyFiltered}
          name="isCompanyFiltered"
          testId="isCompanyFiltered"
          disabled={disabled}
        />
      </Tooltip>
    )
  }

  return (
    <form.Checkbox
      label={texts.labels.isCompanyFiltered}
      name="isCompanyFiltered"
      testId="isCompanyFiltered"
      helperText={texts.helperText.isCompanyFiltered}
      disabled={disabled}
    />
  )
}
